var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useState } from 'react';
import { AonDialog } from '../../components/core/AonDialog';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import { UuiLogo } from '@aonunited/react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import "./AMBestDialog.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AonInput } from '../../components/core/AonInput';
import { addNewClient } from '../../api/marketData/AllStaffCrud';
import { getOktaUserEmail, getOktaUserUid } from '../../api/auth/okta';
import { useAppInfoStore, useErrorStore, useNotificationStore } from '../../store';
import { useNavigate } from 'react-router-dom';
var AddNewClient = function (props) {
    var Body = function () {
        var _a = useState(""), clientName = _a[0], setClientName = _a[1];
        var _b = useState(""), Desription = _b[0], setDescription = _b[1];
        var _c = useState(false), loading = _c[0], setLoading = _c[1];
        var notificationStore = useNotificationStore();
        var navigation = useNavigate();
        var errorStore = useErrorStore();
        var appInfo = useAppInfoStore();
        var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
            var requestorEmail, userInfo, oktaID, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        requestorEmail = getOktaUserEmail();
                        userInfo = appInfo.userInfo;
                        oktaID = getOktaUserUid();
                        return [4 /*yield*/, addNewClient({
                                requestType: "NC",
                                clientName: clientName,
                                requestorAdditionalinfo: Desription,
                                "requestorName": userInfo.displayName,
                                "requestorEmail": requestorEmail,
                                "oktaID": oktaID,
                            })];
                    case 1:
                        _a.sent();
                        notificationStore.showNotification({ message: "Request Submitted successfully", variant: "success", visible: true });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        notificationStore.showNotification({ message: "Something went wrong! Please try again", variant: "error", visible: true });
                        errorStore.showError({ message: "Internal Server Error!!!", code: error_1.status });
                        navigation('/error');
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        props.onClickClose();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return React.createElement("div", { className: 'ambest-body' },
            React.createElement(AonInput, { required: true, label: "Name :", "aria-label": "Outlined", onTextChange: function (event) { return setClientName(event.target.value); }, value: clientName, type: "text" }),
            React.createElement("div", { style: { marginBlock: 16 } },
                React.createElement("div", { style: { paddingBottom: "5px" } },
                    "Additional Information :",
                    React.createElement("span", { style: { color: "red" } }, "*")),
                React.createElement("textarea", { style: { width: "100%" }, cols: 120, rows: 10, required: true, value: Desription, onChange: function (event) { return setDescription(event.target.value); }, placeholder: 'Please provide, country of domicile, web address or any other standard company identifiers, if available, to help the Market Security team approve this request.' })),
            React.createElement("div", { style: { width: "100%", display: "flex", marginBottom: "-27px" } },
                loading ? React.createElement("div", null, "Loading...") : React.createElement(AonButton, { style: { marginRight: "8px" }, disabled: !clientName || !Desription, variant: BUTTON_VARIANT.DEFAULT, onClick: handleSubmit }, "Submit"),
                React.createElement(AonButton, { style: { marginRight: "5px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: props.onClickClose }, "Cancel")));
    };
    var MemoBody = useMemo(function () { return React.createElement(Body, null); }, []);
    return (React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: MemoBody }));
};
export default AddNewClient;
